var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimsAssisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.126,
    height: 32.486,
    viewBox: "0 0 37.126 32.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48322",
    "data-name": "Path 48322",
    d: "M4187.887,979.094a.581.581,0,0,1,.343-.291s16.364-5.306,16.641-5.354l.041-.013a2.26,2.26,0,0,1,1.347.111l.6.193-.1-.3a1.746,1.746,0,0,0-1.663-1.193,1.769,1.769,0,0,0-.541.085l-16.682,5.367a1.733,1.733,0,0,0-1.022.871,1.7,1.7,0,0,0-.1,1.317l6.874,20.718v-3.685l-5.773-17.4A.551.551,0,0,1,4187.887,979.094Z",
    transform: "translate(-4186.665 -972.246)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48323",
    "data-name": "Path 48323",
    d: "M4301.167,1227.935l1.084,3.272a1.158,1.158,0,0,0,.372.533v-3.1l-.353-1.063.353-.113v-1.219l-.718.231A1.15,1.15,0,0,0,4301.167,1227.935Z",
    transform: "translate(-4295.661 -1214.159)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48324",
    "data-name": "Path 48324",
    d: "M4540.71,1021.032a1.747,1.747,0,0,0-1.664,1.193l-.278.84h1.223l.157-.474a.586.586,0,0,1,.562-.4.6.6,0,0,1,.185.03l2.616.841h3.792l-6.052-1.947A1.757,1.757,0,0,0,4540.71,1021.032Z",
    transform: "translate(-4522.01 -1018.71)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48325",
    "data-name": "Path 48325",
    d: "M4419.388,1150.3a.351.351,0,0,1,.093-.118.491.491,0,0,1,.319-.113c.029,0,.055,0,.057,0a.9.9,0,0,1,.2.069.309.309,0,0,1,.123.108.822.822,0,0,0,.173.178.584.584,0,0,0,.694-.053.464.464,0,0,0,.161-.347.411.411,0,0,0-.029-.146.674.674,0,0,0-.054-.11,1.335,1.335,0,0,0-.528-.475,1.5,1.5,0,0,0-.468-.15,1.8,1.8,0,0,0-.932.078,1.51,1.51,0,0,0-.477.292,1.378,1.378,0,0,0-.317.431,1.233,1.233,0,0,0-.115.527v.81a1.138,1.138,0,0,0,.126.527,1.389,1.389,0,0,0,.329.418,1.536,1.536,0,0,0,.48.275,1.729,1.729,0,0,0,.582.1h.05a1.609,1.609,0,0,0,.748-.172,1.318,1.318,0,0,0,.52-.469,1.2,1.2,0,0,0,.054-.108.39.39,0,0,0,.031-.15.459.459,0,0,0-.163-.351.6.6,0,0,0-.709-.045.933.933,0,0,0-.156.169.361.361,0,0,1-.126.111.688.688,0,0,1-.194.063h-.049a.512.512,0,0,1-.187-.032.53.53,0,0,1-.149-.09.361.361,0,0,1-.092-.124.32.32,0,0,1-.029-.157v-.795A.324.324,0,0,1,4419.388,1150.3Z",
    transform: "translate(-4407.264 -1140.695)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48326",
    "data-name": "Path 48326",
    d: "M4487.142,1149.276a.6.6,0,0,0-.765,0,.45.45,0,0,0-.163.347v2.509a.5.5,0,0,0,.165.339.554.554,0,0,0,.387.143h1.7a.557.557,0,0,0,.378-.142.462.462,0,0,0,0-.695.555.555,0,0,0-.378-.142h-1.158v-2.011A.452.452,0,0,0,4487.142,1149.276Z",
    transform: "translate(-4471.958 -1140.719)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48327",
    "data-name": "Path 48327",
    d: "M4550.824,1152.464a.575.575,0,0,0,.372.127h.006a.555.555,0,0,0,.368-.146.438.438,0,0,0,.151-.331v-1.674a1.15,1.15,0,0,0-.126-.527,1.386,1.386,0,0,0-.33-.417,1.523,1.523,0,0,0-.479-.275,1.73,1.73,0,0,0-1.169.01,1.521,1.521,0,0,0-.476.291,1.362,1.362,0,0,0-.317.431,1.321,1.321,0,0,0-.121.527v1.649a.423.423,0,0,0,.167.333.583.583,0,0,0,.742-.011.442.442,0,0,0,.162-.337v-.412h.888v.426A.422.422,0,0,0,4550.824,1152.464Zm-1.051-1.718v-.292a.325.325,0,0,1,.035-.146.365.365,0,0,1,.094-.119.486.486,0,0,1,.484-.081.519.519,0,0,1,.148.089.376.376,0,0,1,.093.125.369.369,0,0,1,.034.157v.267Z",
    transform: "translate(-4531.472 -1140.706)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48328",
    "data-name": "Path 48328",
    d: "M4620.333,1152.6a.456.456,0,0,0,.157-.346v-2.5a.452.452,0,0,0-.156-.341.588.588,0,0,0-.77,0,.45.45,0,0,0-.156.341v2.5a.456.456,0,0,0,.157.346.574.574,0,0,0,.389.142A.558.558,0,0,0,4620.333,1152.6Z",
    transform: "translate(-4598.814 -1140.844)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48329",
    "data-name": "Path 48329",
    d: "M4653.954,1152.109v-1.836a1.132,1.132,0,0,0-.118-.446,1.279,1.279,0,0,0-.674-.616,1.359,1.359,0,0,0-.963-.008,1.829,1.829,0,0,0-.275.136,1.661,1.661,0,0,0-.285-.14,1.358,1.358,0,0,0-1.375.273,1.183,1.183,0,0,0-.272.371,1.017,1.017,0,0,0-.1.437v1.828a.462.462,0,0,0,.158.35.6.6,0,0,0,.771,0,.461.461,0,0,0,.158-.35v-1.789a.169.169,0,0,1,.057-.132.22.22,0,0,1,.287,0,.166.166,0,0,1,.057.132v1.789a.46.46,0,0,0,.158.35.6.6,0,0,0,.767,0,.458.458,0,0,0,.158-.35v-1.789a.162.162,0,0,1,.059-.131.219.219,0,0,1,.287,0,.167.167,0,0,1,.057.132v1.789a.461.461,0,0,0,.158.35.569.569,0,0,0,.388.142.556.556,0,0,0,.379-.141A.457.457,0,0,0,4653.954,1152.109Z",
    transform: "translate(-4627.846 -1140.701)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48330",
    "data-name": "Path 48330",
    d: "M4438.887,1260.046a1.164,1.164,0,0,0-1.161-1.161h-12.183a1.164,1.164,0,0,0-1.161,1.161v3.483a1.164,1.164,0,0,0,1.161,1.161h12.183a1.164,1.164,0,0,0,1.161-1.161Zm-1.161,3.483h-12.183v-3.483h12.183Z",
    transform: "translate(-4413.07 -1245.243)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48331",
    "data-name": "Path 48331",
    d: "M4357.336,1089.867v15.673a.581.581,0,0,0,1.162,0v-15.673a.58.58,0,0,1,.579-.58h17.4a.581.581,0,0,1,.58.58v10.755l.471-.57.689-.9v-9.289a1.743,1.743,0,0,0-1.741-1.741h-17.4A1.743,1.743,0,0,0,4357.336,1089.867Z",
    transform: "translate(-4349.213 -1082.611)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48332",
    "data-name": "Path 48332",
    d: "M4358.5,1536.511v-2.322a.5.5,0,0,1,0-.29.581.581,0,1,0-1.162,0,.5.5,0,0,1,0,.29v2.322a1.743,1.743,0,0,0,1.741,1.741h9.286a1.739,1.739,0,0,1,.07-.477l.2-.684h-9.559A.58.58,0,0,1,4358.5,1536.511Z",
    transform: "translate(-4349.213 -1506.615)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48333",
    "data-name": "Path 48333",
    d: "M4722.6,1616.159h1.761a1.744,1.744,0,0,0,1.593-1.041Z",
    transform: "translate(-4697.099 -1584.522)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48334",
    "data-name": "Path 48334",
    d: "M4817.967,1097.083a.58.58,0,0,1,.238.149,1.732,1.732,0,0,1,1.324.3,1.733,1.733,0,0,0-1.206-1.552l-6.151-1.979a2.89,2.89,0,0,1,.393,1.346Z",
    transform: "translate(-4782.402 -1088.204)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48335",
    "data-name": "Path 48335",
    d: "M4788.836,1523.966a1.981,1.981,0,0,1-.289,1.056v.248a2.9,2.9,0,0,1-1.6,2.59,1.739,1.739,0,0,0,1.389-1.17l1.717-5.175a2.357,2.357,0,0,1-.939.265A6.437,6.437,0,0,0,4788.836,1523.966Z",
    transform: "translate(-4758.378 -1495.375)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48336",
    "data-name": "Path 48336",
    d: "M4629.14,1194.786l-5.562,4.844a.054.054,0,0,1-.054-.005l-2.4-2.5a.134.134,0,0,1-.015-.1l8.567-10.366a.58.58,0,0,0-.894-.74l-8.578,10.38a1.277,1.277,0,0,0-.1,1.384,6.889,6.889,0,0,1-3.173.7c-.1,0-.2,0-.289,0h-.023a.819.819,0,0,0-.769.549s-2.4,8.089-2.409,8.111a.31.31,0,0,0,.414.411l7.992-2.482a.85.85,0,0,0,.56-.8,6.457,6.457,0,0,1,.726-3.442,1.192,1.192,0,0,0,1.188-.2l5.574-4.854a.58.58,0,1,0-.761-.876Zm-7.889,9.148-4.617,1.433,2.543-2.544c.016,0,.03,0,.046,0a.871.871,0,1,0-.871-.87c0,.015,0,.03,0,.045l-3.138,3.14,1.664-5.6h.054a7.757,7.757,0,0,0,3.963-.973l1.338,1.4A7.225,7.225,0,0,0,4621.251,1203.934Z",
    transform: "translate(-4593.117 -1175.544)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48337",
    "data-name": "Path 48337",
    d: "M4824.579,1321.56l-3.844,3.7a.581.581,0,0,0,.4,1,.575.575,0,0,0,.4-.162l3.844-3.7a.58.58,0,1,0-.8-.837Z",
    transform: "translate(-4790.389 -1304.781)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48338",
    "data-name": "Path 48338",
    d: "M4436.58,1417.929h.06c.079,0,.163,0,.253,0a6.747,6.747,0,0,0,1.812-.241.577.577,0,0,0-.47-.243h-13.271a.58.58,0,1,0,0,1.161H4435.1A2,2,0,0,1,4436.58,1417.929Z",
    transform: "translate(-4413.07 -1396.262)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48339",
    "data-name": "Path 48339",
    d: "M4434.561,1466.236h-9.6a.581.581,0,1,0,0,1.161h9.252Z",
    transform: "translate(-4413.07 -1442.726)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48340",
    "data-name": "Path 48340",
    d: "M4424.383,1515.6a.581.581,0,0,0,.581.58h8.563l.345-1.161h-8.908A.581.581,0,0,0,4424.383,1515.6Z",
    transform: "translate(-4413.07 -1489.19)",
    fill: "#6e6e6e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsAssisted);
export default __webpack_public_path__ + "static/media/Claims-assisted.f7866493eedeb09a3f36cb637c5840e4.svg";
export { ForwardRef as ReactComponent };